<app-stepper-container
  [steps]="steps"
  [item]="jobData$ | async"
  [form]="jobForm"
  [urlRoot]="rootUrl"
  (stepChanged)="onStepChanged($event)"
  [hideAdditionalSteps]="false">
</app-stepper-container>
